module.exports = __webpack_public_path__ + "img/arrow_left.e62b0422.svg";